import { useFlowReveal } from "@/hooks/useFlowReveal";

const audiences = [
  {
    who: "Banks, NBFCs & listed entities",
    rule: "SEBI circular",
    what: "C3 reporting, C4 audit and annual re-assessment, with version-controlled reports for each cycle.",
  },
  {
    who: "Government & public sector",
    rule: "GIGW 3.0 · RPwD Act 2016",
    what: "Audits of portals and citizen services against the Indian government guidelines and the disability rights law.",
  },
  {
    who: "E-commerce & D2C brands",
    rule: "WCAG 2.2 AA",
    what: "Product pages, checkout and forms that every customer can use, tested with keyboard and screen reader.",
  },
  {
    who: "SaaS & exporters",
    rule: "VPAT / ACR · ADA · EAA",
    what: "Conformance reports your overseas buyers ask for, under ADA, Section 508 and the European Accessibility Act.",
  },
];

const AudienceSection = () => {
  const flowRef = useFlowReveal<HTMLUListElement>();

  return (
  <section id="who-we-serve" className="section-padding section-alt" aria-labelledby="audience-heading">
    <div className="max-w-7xl mx-auto">
      <p className="eyebrow mb-4">Who we serve</p>
      <h2 id="audience-heading" className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 max-w-3xl">
        Built for teams that have to prove accessibility
      </h2>
      <p className="mb-8 max-w-2xl text-lg leading-relaxed text-muted-foreground">
        We have worked across enterprise and BFSI ecosystems, where accessibility has to be documented, repeatable and ready for a regulator or a buyer to inspect.
      </p>
      <ul ref={flowRef} className="grid list-none gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-4">
        {audiences.map((a, i) => (
          <li key={a.who} className="flow-step border-t-2 border-foreground pt-5" style={{ "--i": Math.min(i, 5) } as React.CSSProperties}>
            <p className="font-mono text-xs font-medium uppercase tracking-wider text-primary">{a.rule}</p>
            <h3 className="mt-2 font-display text-lg font-bold text-foreground">{a.who}</h3>
            <p className="mt-3 text-base leading-relaxed text-muted-foreground">{a.what}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
  );
};

export default AudienceSection;
